import {Component, OnInit, OnDestroy} from '@angular/core';
import {Globals} from '@myApp/globals.ts';

import {EventService} from '@myServices/event.service';
import {AuthenticationService} from '@myServices/authentication.service';
import {ModalService} from '@myServices/modal.service';
import {MgWalletComponent} from '../mg-wallet';
import {Subscription} from 'rxjs/Subscription';
import {LoginComponent} from '@myApp/Modules/Authentication/components/login/login.component';
import {OverlayService} from '@Shared/services';
import {NavigationStart, Router} from '@angular/router';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {

    public isLoggedIn;
    private isSideBarOpen: any;
    private subscriptions: Subscription[] = [];

    constructor(
        private globals: Globals,
        private eventService: EventService,
        private authenticationService: AuthenticationService,
        private modalService: ModalService,
        private overlayService: OverlayService,
        private router: Router,
    ) {
        this.isLoggedIn = this.eventService.isUserLoggedIn;
    }

    ngOnInit() {
        const authStatusSubscriber = this.eventService.getAuthenticationStatus()
            .subscribe(data => {
                this.isLoggedIn = data.status;
            });

        const sidebarStatusSubs = this.globals.getSideBarStatus().subscribe(isSideBarOpen => {
            this.isSideBarOpen = isSideBarOpen;
        });
        this.subscriptions.push(sidebarStatusSubs);
        this.subscriptions.push(authStatusSubscriber);

        this.router.events.filter(event => event instanceof NavigationStart).subscribe(res => {
            setTimeout(() => {
                this.globals.onSideBarChange(false);
            }, 100);
        });
    }

    closeSideBar() {
        setTimeout(() => {
            this.globals.onSideBarChange(false);
        }, 500);
    }

    MgModal() {
        let inputs = {
            isMobile: false
        };
        this.modalService.init(MgWalletComponent, inputs, {});
    }

    toggleSideBar() {
        this.globals.onSideBarChange(!this.isSideBarOpen);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    loginModalMobile() {
        let inputs = {
            isMobile: true
        };
        this.modalService.init(LoginComponent, inputs, {});
    }

    logout() {
        this.authenticationService.currentGame = 0;
        this.overlayService.onOverlayChange(true);
        this.authenticationService.logout()
            .subscribe(response => {
                if (response.status) {
                    this.authenticationService.initializeSite()
                        .then(status => {
                            if (status) {
                                this.overlayService.onOverlayChange(false);
                                this.authenticationService.loginManager(response.data.user, false);
                                this.authenticationService.alive = false;
                                window.location.reload();
                            }
                            this.overlayService.onOverlayChange(false);
                        })
                        .catch(err => {
                            this.overlayService.onOverlayChange(false);
                            console.log(err);
                        });

                }
                this.overlayService.onOverlayChange(false);
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/sidebar/sidebar.component.ts